module.exports = __webpack_public_path__ + "img/make-sure-you-understand.874cca4f.png";